import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";

const TIME_ZONE_STORAGE_KEY = 'serverTimeZone';
const dateFormat = 'DD MMM YYYY'; //03 Jun 2022
const dateTimeFormat = 'DD MMM YYYY, h:mm A'; // 03 Jun 2022, 5:15PM
const dayNameDateFormat = 'ddd, DD MMM YYYY'; // Fri, 03 Jun 2022
const dayNameDateTimeFormat = 'ddd, DD MMM YYYY, h:mm A'; // Fri, 03 Jun 2022, 5:15PM
const timeFormat = 'h:mm A'; // 5:15PM
const timestampFormat = 'YYYY-MM-DD HH:mm:ssZZ';
const timeDisplayFormat = 'hh:mm A';

const setDayJSTimeZone = (timeZoneString) => {
    dayjs.extend(utc);
    dayjs.extend(timezone);
    if (timeZoneString) {
        dayjs.tz.setDefault(timeZoneString);
    }
};

export {
    TIME_ZONE_STORAGE_KEY,
    setDayJSTimeZone,
    timestampFormat,
    timeDisplayFormat,
    dateFormat,
    dateTimeFormat,
    dayNameDateFormat,
    dayNameDateTimeFormat,
    timeFormat
};
